import React from 'react';
import PropTypes from 'prop-types';
import {
    BoxscoreInfoContainer,
    BoxscoreTeamCollapsibleWrapper
} from './BoxscoreInfo.style';
import Content from './boxscoreInfo/Content';
import { generateContent } from './boxscoreInfo/utils/generateContent';
import Collapsible from './boxscoreInfo/Collapsible';

const BoxscoreInfo = ({
    info = [],
    className,
    handlers,
    expandedFromTop,
    enableToggle
}) => {
    const hasInfo = info.length;
    const { defaultVisible, togglable } = generateContent(info, enableToggle);
    const visibleContent = <Content info={ defaultVisible } />;

    return (
        hasInfo ? <BoxscoreInfoContainer className={ className }>
            <BoxscoreTeamCollapsibleWrapper>
               <Collapsible
                    visibleContent={ visibleContent }
                    showButton={ !!togglable.length }
                    collapsibleContent={ <Content info={togglable} /> }
                    handlers={handlers}
                    expandedFromTop={expandedFromTop}
                />
            </BoxscoreTeamCollapsibleWrapper>
        </BoxscoreInfoContainer> : null
    );
};

BoxscoreInfo.propTypes = {
    info: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        fieldList: PropTypes.array
    })),
    className: PropTypes.string,
    handlers: PropTypes.object,
    expandedFromTop: PropTypes.bool,
    enableToggle: PropTypes.bool
};

export default BoxscoreInfo;
